import React, { useEffect } from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import { WizardStepProps } from '~/components/organism/Wizard/context/WizardContext';
import { useUpdateAccountMutation } from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import useDHFlag from '~/hooks/useDHFlag';
import useWizardStep from '~/hooks/useWizardStep';
import isDevEnvironment from '~/util/isDevEnviroment';
import removeTypenames from '~/util/removeTypenames';
import Catalog from '~/Catalog';

export const id = 'WelcomeScreen';
export const title = `Welkom bij ${Catalog.companyName}`;

const text = {
  body: (
    <>
      Gefeliciteerd met het aanmaken van een nieuw account!
      <br />
      <br />
      In deze wizard gaan we in stappen jouw account inrichten. Dit neemt
      ongeveer 10 minuten in beslag. Na het voltooien van deze wizard, heb je
      een belangrijke stap gezet richting het realiseren van meer loyale klanten
      en het boosten van je serviceniveau.
    </>
  ),
};

export type OutputType = {
  type: typeof id;
};

export const Component: React.FCC<WizardStepProps> = props => {
  const [, api] = useWizardStep(props.step.id);
  const account = useCurrentAccount();
  const [updateAccount, { loading }] = useUpdateAccountMutation();
  const isDeveloper = useDHFlag('is-developer');
  const isDev = isDevEnvironment();

  const onClick = async () => {
    await updateAccount({
      variables: {
        accountId: account.id,
        update: {
          name: account.name,
          settings: {
            ...removeTypenames(account.AccountSettings ?? {}),
            metadata: { setup: { completed: true } },
          },
        },
      },
    }).then(() => {
      window.location.reload();
    });
  };

  useEffect(() => {
    api.free({ type: id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Body>{text.body}</Body>
      {(isDeveloper || isDev) && (
        <JustificationContainer align="center" width="100%" justification="end">
          <Button
            label="Skip onboarding"
            onClick={onClick}
            loading={loading}
            size="large"
          />
        </JustificationContainer>
      )}
    </>
  );
};

export default {
  id,
  title,
};
